<template>
  <el-dialog
    :title="dialogInfo.title"
    :visible.sync="dialogInfo.show"
    v-if="dialogInfo.show"
    width="750px"
  >
    <el-form
      size="small"
      label-position="right"
      label-width="100px"
      :rules="rules"
      :model="formData"
      ref="addForm"
    >
      <el-form-item required label="审核结果：">
        <el-radio-group v-model="formData.auditSchedule" @change="encumbrance">
          <el-radio
            v-for="item in auditData"
            :key="item.paramKey"
            :label="item.paramKey"
            >{{ item.paramValue }}</el-radio
          >
        </el-radio-group>
      </el-form-item>
      <el-form-item
        prop="auditContent"
        label="驳回原因："
        v-if="formData.auditSchedule === 1"
      >
        <el-input
          v-model="formData.auditContent"
          show-word-limit
          :maxlength="200"
          placeholder="请输入驳回原因"
          type="textarea"
          autosize
        />
      </el-form-item>
      <el-form-item required label="短信通知：">
        <el-radio-group v-model="formData.isNotice">
          <el-radio
            v-for="item in isNoticeData"
            :key="item.paramKey"
            :label="item.paramKey"
            >{{ item.paramValue }}</el-radio
          >
        </el-radio-group>
      </el-form-item>
      <el-form-item required label="消息内容：" v-if="this.formData.isNotice">
        <el-input
          v-model="auditContent"
          show-word-limit
          :maxlength="100"
          placeholder="请输入职能处室联系人联系方式"
          disabled
        />
      </el-form-item>
      <el-form-item required label="发送对象：" v-if="this.formData.isNotice">
        <span v-for="(item, index) in dialogInfo.auditMens" :key="item.uuid">
          {{ item.auditUserName
          }}{{ index === dialogInfo.auditMens.length - 1 ? "" : "、" }}
        </span>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <butn @click.native="closeDia" title="取消"></butn>
      <butn btntype="primary" @click.native="sureImport" title="确定"></butn>
    </div>
  </el-dialog>
</template>

<script>
// auditUserId---auditUserId
import butn from "@/components/button/index";
import { auditBatch } from "@/api/studyService";

export default {
  components: { butn },
  props: {
    dialogInfo: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    auditContent() {
      if (this.formData.auditSchedule === 1) {
        return `您好，您提交的{班级名称}审核未通过，原因：{驳回原因}`;
      } else {
        return `您好，您提交的{班级名称}审核已通过`;
      }
    },
  },
  data() {
    return {
      file: [],
      formData: {
        auditSchedule: 1,
        isNotice: true,
        auditContent: "",
      },
      rules: {
        auditContent: [
          { required: true, message: "请输入驳回原因", trigger: "blur" },
        ],
      },
      auditData: [
        { paramValue: "不同意", paramKey: 1 },
        { paramValue: "同意", paramKey: 2 },
      ],
      isNoticeData: [
        { paramValue: "否", paramKey: false },
        { paramValue: "是", paramKey: true },
      ],
    };
  },
  methods: {
    encumbrance(val) {
      this.formData.isNotice = val === 1;
    },
    closeDia() {
      this.$emit("close", false);
    },
    sureImport() {
      this.$refs["addForm"].validate((valid) => {
        if (valid) {
          const mens = this.dialogInfo.auditMens;
          let params = {
            ...this.formData,
            noticeType: 0,
            classAuditHistoryVoList: mens.map((x) => {
              return {
                auditApplyId: x.auditApplyId,
                sendPerson: [x.auditUserId],
                sendMessage:
                  this.formData.auditSchedule === 1
                    ? `您好，您提交的${x.className}审核未通过，原因：${this.formData.auditContent}`
                    : `您好，您提交的${x.className}审核已通过`,
              };
            }),
          };
          auditBatch(params).then(({ code, msg }) => {
            if (code !== 0) return;
            this.$message({
              type: "success",
              message: msg,
            });
            this.$emit("close", true);
          });
        }
      });
    },
  },
};
</script>

<style>
</style>